import React, { useState } from "react";
import Form_Header from "../../../common/form-header/Form_Header";
import "./Create_Account_Step2.css";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import White_Btn from "../../../common/common-btn/white-btn/White_Btn";

const Create_Account_Step2 = ({ setStep, formData, setFormData }) => {
  const [selected, setSelected] = useState(formData?.gender || "");
  const [error, setError] = useState("");

  const handleNext = () => {
    if (!selected) {
      setError("Please select your gender to continue");
      return;
    }
    setFormData((prev) => ({ ...prev, gender: selected }));
    setStep(3);
  };

  return (
    <section className="step1_wrapper step2_wrapper">
      <Form_Header step={2} totalSteps={6} />
      <div className="gender_selection_div">
        <h2 className="select_title">Select Your Gender</h2>

        <div className="select_gender_div">
          <div
            className={`gender_selection ${selected === "female" ? "active" : ""}`}
            onClick={() => {
              setSelected("female");
              setError("");
            }}
          >
            <img
              src="/Assets/images/gym_member/woman.png"
              alt="female"
              className="gender_img"
            />
          </div>

          <div
            className={`gender_selection ${selected === "male" ? "active" : ""}`}
            onClick={() => {
              setSelected("male");
              setError("");
            }}
          >
            <img
              src="/Assets/images/gym_member/man.png"
              alt="male"
              className="gender_img"
            />
          </div>
        </div>

        {/* Validation Error */}
        {error && <p className="text-danger text-center mt-2">{error}</p>}

        <div className="form_btn_holder">
          <White_Btn btnText={"Back"} onClick={() => setStep(1)} />
          <Common_Btn btnText={"Next"} onClick={handleNext} />
        </div>
      </div>
    </section>
  );
};

export default Create_Account_Step2;